module.exports = __webpack_public_path__ + "img/pic_subject_physics.910f1c44.png";